module.exports = __webpack_public_path__ + "static/media/bunnystew.29ccdf76.png";